import { Component } from '@angular/core'
import { ConsentManagementFormComponent } from '@spartacus/storefront'
import { CookieService } from 'ngx-cookie-service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { EbUserIdService } from '../../../../auth/services/eb-user-id.service'

@Component({
    selector: 'eb-consent-management-form',
    templateUrl: './eb-consent-management-form.component.html',
    styleUrls: ['./eb-consent-management-form.component.scss'],
    standalone: false
})
export class EbConsentManagementFormComponent extends ConsentManagementFormComponent {
  constructor(
    protected cookieService: CookieService,
    protected userIdService: EbUserIdService
  ) {
    super()
  }

  isActiveAsmAgent(): Observable<boolean> {
    return this.userIdService
      .isEmulated()
      .pipe(map(isEmulated => isEmulated && !!this.cookieService.get('asAgent')))
  }
}
